<template>
	<CreationWizardStepWrapper>
		<template #header>
			<FillButtonDropdownDataHeader v-bind="$props" v-on="$listeners" />
		</template>
		<div class="display-flex flex-1 flex-wrap height-100">
			<div class="content-container flex-col-12">
				<div class="content-area">
					<ButtonDropdownInputTextField v-model="title" title="Title" description="The name of the button dropdown" />
					<ButtonDropdownInputForm
						:iconName.sync="iconName"
						:iconColor.sync="iconColor"
						:tooltipText.sync="tooltip"
						:mainScreenText.sync="mainScreenText"
					/>
				</div>
			</div>
			<div class="flex-1 flex-center--end">
				<PrimaryButton @click="create" :disabled="!isValid" :loading="loading">Create</PrimaryButton>
			</div>
		</div>
	</CreationWizardStepWrapper>
</template>

<script>
import props from './FillButtonDropdownData.props';
import FillButtonDropdownDataHeader from './FillButtonDropdownDataHeader.vue';
import WizardStepMixin from '../WizardStepMixin';
import { EDIT_BUTTON_DROPDOWN_ROUTE_NAME } from '@/router/router.const';
import { createButtonDropdown } from '@/store/modules/buttonDropdowns/actions';
import { mapActionsShorthand } from '@/store/utils/mappers';
const DEFAULT_ICON_NAME = 'mdi-format-list-bulleted';
const DEFAULT_ICON_COLOR = '#000000';
import ButtonDropdownInputTextField from './ButtonDropdownInputTextField.vue';
import ButtonDropdownInputForm from './ButtonDropdownInputForm.vue';
export default {
	name: 'FillButtonDropdownData',
	mixins: [WizardStepMixin],
	props,
	components: { FillButtonDropdownDataHeader, ButtonDropdownInputTextField, ButtonDropdownInputForm },
	computed: {
		isValid() {
			return !!this.title && !!this.iconName && this.iconName !== 'ply-element-transparent';
		},
	},
	methods: {
		...mapActionsShorthand({ createButtonDropdown }),
		async create() {
			this.loading = true;
			const buttonDropdownData = {
				project: this.selectedProjectId,
				title: this.title,
				placement: this.selectedPlacementId,
				icon_name: this.iconName,
				icon_color: this.iconColor,
				tooltip_text: this.tooltip,
				main_screen_text: this.mainScreenText,
			};
			try {
				this.closeWizard();
				const res = await this.createButtonDropdown(buttonDropdownData);
				this.$router.push({ name: EDIT_BUTTON_DROPDOWN_ROUTE_NAME, params: { id: res.id } });
			} catch (err) {
				this.$toast.error(err.message);
			} finally {
				this.loading = false;
			}
		},
	},
	data() {
		return {
			title: '',
			iconName: DEFAULT_ICON_NAME,
			iconColor: DEFAULT_ICON_COLOR,
			tooltip: '',
			mainScreenText: '',
			loading: false,
			advancedFeatures: false,
		};
	},
};
</script>

<style scoped lang="scss">
.content-container {
	max-height: 380px;
	overflow-y: auto;
}
</style>
